<template>
    <div class="pictures-documents-list">
        <div class="upload-pictures-list">
            <div class="upload-pictures-box" v-for="(pic, $index) in media" v-if="media">
                <div class="upload-pictures-img pointer"
                     @click="showImage($index)"
                     :key="$index"
                     :style="{ backgroundImage: 'url(' + pic.thumb + ')'}"
                ></div>
            </div>
            <LightBox
                      v-if="media && media.length"
                      :media="media"
                      ref="lightbox"
                      :showLightBox="false"
            ></LightBox>
        </div>
    </div>
</template>

<script>
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')


export default {
    name: "ViewPictures",
    props: ['pictures'],
    components: {
        LightBox,
    },
    data: () => {
        return {
            media: [
            ],
        }
    },
    mounted() {
        let pictures = [];
        if(typeof this.pictures == "object") {
            pictures = Object.values(this.pictures);
        } else {
            pictures = this.pictures;
        }

        if(pictures.length) {
            pictures.forEach(($picture) => {
                if($picture.path) {
                    let mediaItem = {
                        thumb: $picture.thumb,
                        src: $picture.path,
                        type: 'image'
                    }
                    this.media.push(mediaItem);
                }
            });
        }



    },
    methods: {
        showImage($index) {
            this.$refs.lightbox.showImage($index)
        }
    }

}
</script>

<style scoped>

</style>
